import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { PassengerNameChangeServicingRQ } from 'src/app/model/request/passenger-name-change-screen-request';
import { PassengerDetails, PassengerNameChangeScreen } from 'src/app/model/screen/change-passenger-name-screen';
import { ApiService } from 'src/app/service/api.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import orderChangeJSON from 'src/assets/json/split-booking/request/order-change-request-default-params.json';

@Component({
  selector: 'app-passenger-name-change-screen',
  templateUrl: './passenger-name-change-screen.component.html',
  styleUrls: ['./passenger-name-change-screen.component.scss']
})
export class PassengerNameChangeScreenComponent implements OnInit {
  submitted = false;
  passengerNameChangeForm: any;
  nameTitle: any = ['MR', 'MRS', 'MISS', 'MS', 'DR'];
  passengerNameChangeScreenDetails: PassengerNameChangeScreen = {} as PassengerNameChangeScreen;
  passengersList: PassengerDetails[] = [];

  public passengerIndex: any;
  public isPassengerSelected: boolean = false;
  public passengerID: any;

  passengerNameChangeRQ: PassengerNameChangeServicingRQ = {} as PassengerNameChangeServicingRQ;
  passengerNameChangeScreen: any;
  constructor(
    private sandboxPageStateService: SandboxPageStateService,
    private formBuilder: FormBuilder,

    private localAssetReaderService: LocalAssetReaderService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private apiService: ApiService
  ) {
    {
      Object.entries(orderChangeJSON).forEach((entry) => {
        const [key, value] = entry;
        this.inputParamsMap.set(key, value);
      });
    }
    this.passengerNameChangeForm = this.formBuilder.group({
      passengerNameFormArray: this.formBuilder.array([])
    });
  }
  inputParamsMap = new Map();

  public passengerScreenData: any;
  ngOnInit(): void {
    let passengerNameChangeScreen = this.sandboxPageStateService.getPassengerDetailScreenData();
    this.mapPassengerDetails(passengerNameChangeScreen.passengerDetail);
  }

  mapPassengerDetails(passengerBookingDetails: any) {
    let passenderDetails: PassengerDetails[] = [];
    passengerBookingDetails.forEach((passenger: any) => {
      this.passengersList.push({
        passengerName: passenger.passengerName,
        passengerNameTitle: passenger.passengerNameTitle,
        passengerType: passenger.passengerType,
        passengerSurName: passenger.passengerSurName
      });

      this.passengerNameChangeForm.get('passengerNameFormArray')?.push(
        this.formBuilder.group({
          passengerName: passenger.passengerName,
          passengerNameTitle: passenger.passengerNameTitle,
          passengerType: passenger.passengerType,
          passengerSurName: passenger.passengerSurName,
          gender: new FormControl('')
        })
      );
    });
    this.passengerNameChangeScreenDetails.passengerDetails = this.passengersList;
  }

  closePanel() {
    let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  getIndex(i: any) {
    this.passengerIndex = i;
    this.isPassengerSelected = true;
  }

  onSubmit() {
    this.initPassengerNameUpdateRequest();
  }
  async initPassengerNameUpdateRequest() {
    let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    let pnr = passengerScreenData.pnrNumber;
    let selectedPassengerOldDetail = passengerScreenData.passengerDetail[this.passengerIndex];
    let passengerID = selectedPassengerOldDetail.passengerId;

    let selectedPassengerNewDetail = this.passengerNameChangeForm.value.passengerNameFormArray[this.passengerIndex];

    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_NAME_CHANGE_REQUEST_TEMPLATE);
    this.passengerNameChangeRQ = JSON.parse(jsonRequestTemplate as any);

    this.inputParamsMap.set('##OrderID##Owner##', 'BA');
    this.inputParamsMap.set('##OrderID##_##', pnr);
    this.inputParamsMap.set('##New##PassengerID##', passengerID);
    this.inputParamsMap.set('##Individual##NameTitle1##', selectedPassengerNewDetail.passengerNameTitle);
    this.inputParamsMap.set('##Individual##GivenName1##', selectedPassengerNewDetail.passengerName);
    this.inputParamsMap.set('##Individual##Surname1##', selectedPassengerNewDetail.passengerSurName);
    this.inputParamsMap.set('##ActionType##', 'UPDATE');

    this.inputParamsMap.set('##Previous##PassengerID##', passengerID);
    this.inputParamsMap.set('##Individual##NameTitle2##', selectedPassengerOldDetail.passengerNameTitle);
    this.inputParamsMap.set('##Individual##GivenName2##', selectedPassengerOldDetail.passengerName);
    this.inputParamsMap.set('##Individual##Surname2##', selectedPassengerOldDetail.passengerSurName);
    this.inputParamsMap.set('##ActionType##', 'Delete');

    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.passengerNameChangeRQ), this.inputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderChange17_2_V4'
      }),
      responseType: 'text'
    });
    this.updateSandboxPassengerDetail(this.sandboxPageStateService.ORDERCHANGE_NAME_CHANGE_REQUEST_TEMPLATE);
  }

  updateSandboxPassengerDetail(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      this.submitted = false;
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
      passengerScreenData.xml = this.sandboxPageStateService.getResponseFromMap(url);
      passengerScreenData.jsonData = this.xmlToJsonParserService.parseXMLToJSON(passengerScreenData.xml!);
      passengerScreenData.bookingPassengerDetailType = 'your-booking-screen-passenger';

      let selectedPassengerOldDetail = passengerScreenData.passengerDetail[this.passengerIndex];
      let selectedPassengerNewDetail = this.passengerNameChangeForm.value.passengerNameFormArray[this.passengerIndex];
      selectedPassengerOldDetail.passengerName = selectedPassengerNewDetail.passengerName;
      selectedPassengerOldDetail.passengerSurName = selectedPassengerNewDetail.passengerSurName;
      selectedPassengerOldDetail.passengerNameTitle = selectedPassengerNewDetail.passengerNameTitle;
      selectedPassengerOldDetail.passengerGender = selectedPassengerNewDetail.passengerGender;
      passengerScreenData.passengerDetail[this.passengerIndex] = selectedPassengerOldDetail;
      this.sandboxPageStateService.updatePassengerDetailScreenData(passengerScreenData);

      patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }
}
